import React, { useState } from 'react';
import { Plus, Calendar, Users, Send, BarChart2, Copy, Trash2, Edit } from 'lucide-react';
import { Layout } from '../components/layout/Layout';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { Badge } from '../components/ui/Badge';
import { Modal } from '../components/ui/Modal';
import { Input } from '../components/ui/Input';
import { Textarea } from '../components/ui/Textarea';
import { Select } from '../components/ui/Select';
import { useToast } from '../components/ui/Toast';
import { campaigns as initialCampaigns } from '../utils/mockData';
export function Campanhas() {
  const {
    addToast
  } = useToast();
  const [campaigns, setCampaigns] = useState(initialCampaigns);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const handleCreateCampaign = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
      setIsModalOpen(false);
      addToast('Campanha agendada com sucesso!', 'success');
      // Add mock campaign
      setCampaigns([...campaigns, {
        id: Math.random().toString(),
        name: 'Nova Campanha',
        targetAudience: 'Todos os Clientes',
        status: 'Agendada',
        recipientsCount: 450,
        metrics: {
          sent: 0,
          delivered: 0,
          responded: 0
        }
      }]);
    }, 1500);
  };
  const handleDelete = (id: string) => {
    if (confirm('Tem certeza que deseja excluir esta campanha?')) {
      setCampaigns(campaigns.filter(c => c.id !== id));
      addToast('Campanha excluída', 'info');
    }
  };
  const handleDuplicate = () => {
    addToast('Campanha duplicada com sucesso', 'success');
  };
  return <Layout data-id="element-235">
      <div className="space-y-8" data-id="element-236">
        <div className="flex justify-between items-center" data-id="element-237">
          <div data-id="element-238">
            <h1 className="text-3xl font-bold text-white" data-id="element-239">Campanhas</h1>
            <p className="text-text-muted" data-id="element-240">
              Crie e gerencie disparos de mensagens em massa.
            </p>
          </div>
          <Button variant="primary" icon={<Plus className="h-4 w-4" data-id="element-242" />} onClick={() => setIsModalOpen(true)} data-id="element-241">
            Criar Campanha
          </Button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-243">
          {campaigns.map(campaign => <Card key={campaign.id} className="p-6 flex flex-col h-full group relative" hover data-id="element-244">
              {/* Hover Actions */}
              <div className="absolute top-4 right-4 flex gap-2 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-245">
                <button onClick={handleDuplicate} className="p-1.5 bg-slate-700 rounded text-white hover:bg-primary transition-colors" title="Duplicar" data-id="element-246">
                  <Copy className="h-4 w-4" data-id="element-247" />
                </button>
                <button className="p-1.5 bg-slate-700 rounded text-white hover:bg-primary transition-colors" title="Editar" data-id="element-248">
                  <Edit className="h-4 w-4" data-id="element-249" />
                </button>
                <button onClick={() => handleDelete(campaign.id)} className="p-1.5 bg-slate-700 rounded text-white hover:bg-red-500 transition-colors" title="Excluir" data-id="element-250">
                  <Trash2 className="h-4 w-4" data-id="element-251" />
                </button>
              </div>

              <div className="flex justify-between items-start mb-4" data-id="element-252">
                <Badge variant={campaign.status === 'Enviada' ? 'success' : campaign.status === 'Agendada' ? 'warning' : 'neutral'} dot data-id="element-253">
                  {campaign.status}
                </Badge>
              </div>

              <h3 className="text-xl font-bold text-white mb-2" data-id="element-254">
                {campaign.name}
              </h3>

              <div className="space-y-3 mb-6 flex-1" data-id="element-255">
                <div className="flex items-center text-sm text-text-muted" data-id="element-256">
                  <Users className="h-4 w-4 mr-2 text-primary" data-id="element-257" />
                  {campaign.targetAudience} ({campaign.recipientsCount})
                </div>
                {campaign.sentDate && <div className="flex items-center text-sm text-text-muted" data-id="element-258">
                    <Calendar className="h-4 w-4 mr-2 text-primary" data-id="element-259" />
                    Enviada em {campaign.sentDate}
                  </div>}
              </div>

              {campaign.metrics ? <div className="grid grid-cols-3 gap-2 pt-4 border-t border-slate-700" data-id="element-260">
                  <div className="text-center" data-id="element-261">
                    <div className="text-lg font-bold text-white" data-id="element-262">
                      {campaign.metrics.sent}
                    </div>
                    <div className="text-[10px] text-text-muted uppercase" data-id="element-263">
                      Enviados
                    </div>
                  </div>
                  <div className="text-center" data-id="element-264">
                    <div className="text-lg font-bold text-emerald-400" data-id="element-265">
                      {campaign.metrics.delivered}
                    </div>
                    <div className="text-[10px] text-text-muted uppercase" data-id="element-266">
                      Entregues
                    </div>
                  </div>
                  <div className="text-center" data-id="element-267">
                    <div className="text-lg font-bold text-primary-light" data-id="element-268">
                      {campaign.metrics.responded}
                    </div>
                    <div className="text-[10px] text-text-muted uppercase" data-id="element-269">
                      Respostas
                    </div>
                  </div>
                </div> : <div className="pt-4 border-t border-slate-700" data-id="element-270">
                  <Button variant="outline" className="w-full" icon={<Send className="h-4 w-4" data-id="element-272" />} data-id="element-271">
                    Continuar Edição
                  </Button>
                </div>}
            </Card>)}

          {/* Create New Card Placeholder */}
          <button onClick={() => setIsModalOpen(true)} className="border-2 border-dashed border-slate-700 rounded-xl p-6 flex flex-col items-center justify-center text-text-muted hover:text-primary hover:border-primary hover:bg-slate-800/50 transition-all group h-full min-h-[250px]" data-id="element-273">
            <div className="h-12 w-12 rounded-full bg-slate-800 group-hover:bg-primary/10 flex items-center justify-center mb-4 transition-colors" data-id="element-274">
              <Plus className="h-6 w-6" data-id="element-275" />
            </div>
            <span className="font-medium" data-id="element-276">Nova Campanha</span>
          </button>
        </div>
      </div>

      {/* Campaign Builder Modal */}
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} title="Criar Nova Campanha" size="lg" footer={<>
            <Button variant="ghost" onClick={() => setIsModalOpen(false)} data-id="element-278">
              Cancelar
            </Button>
            <Button variant="outline" data-id="element-279">Agendar</Button>
            <Button variant="primary" onClick={handleCreateCampaign} isLoading={isLoading} icon={<Send className="h-4 w-4" data-id="element-281" />} data-id="element-280">
              Enviar Agora
            </Button>
          </>} data-id="element-277">
        <form className="space-y-6" data-id="element-282">
          <Input label="Nome da Campanha" placeholder="Ex: Promoção de Natal" data-id="element-283" />

          <div className="grid grid-cols-2 gap-4" data-id="element-284">
            <Select label="Público Alvo" options={[{
            value: 'todos',
            label: 'Todos os Clientes'
          }, {
            value: 'vip',
            label: 'Clientes VIP'
          }, {
            value: 'inativos',
            label: 'Inativos > 30 dias'
          }]} data-id="element-285" />
            <div className="flex items-end pb-2" data-id="element-286">
              <span className="text-sm text-emerald-400 font-medium" data-id="element-287">
                450 contatos selecionados
              </span>
            </div>
          </div>

          <Textarea label="Mensagem" placeholder="Olá {nome}, aproveite nossas ofertas..." className="h-32" data-id="element-288" />
          <p className="text-xs text-text-muted" data-id="element-289">
            Variáveis disponíveis: {'{nome}'}, {'{loja}'}
          </p>

          <div className="p-4 bg-slate-800 rounded-lg border border-slate-700" data-id="element-290">
            <h4 className="text-sm font-bold text-white mb-2" data-id="element-291">Preview</h4>
            <div className="bg-slate-900 p-3 rounded-lg text-sm text-white" data-id="element-292">
              Olá Maria, aproveite nossas ofertas especiais na Rota's Makeup!
            </div>
          </div>
        </form>
      </Modal>
    </Layout>;
}